






























import { Booking } from '@bookings/interfaces/booking';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BookingForm from '@bookings/components/booking-form/booking-form.vue';

@Component({
  name: 'bc-public-booking-request-view-modal',
  components: {
    'bpc-booking-form': BookingForm,
  },
})
export default class PublicBookingRequestViewModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ default: null }) readonly booking!: Booking;
  @Prop({ type: String, default: 'public-booking-request-view-modal' })
  readonly viewModalId: string;
  @Prop({ type: String, default: 'global.modals.booking-request-view.title' })
  readonly modalTitle: string;
  @Prop({ type: String, default: 'global.modals.booking-request-view.body' })
  readonly modalBody: string;

  //const :

  //variable

  //METHODS

  closeModal() {
    this.$emit('close-modal');
  }

  // WATCHERS
}
